export default __webpack_public_path__ + "static/media/ph-city.ec195338.png";